import type { VisualizerFrame } from './evaluate';
/** Compact, comparable summary of a visualizer frame (tests and diagnostics; no user data). */
export function visualizerDigest(frame: VisualizerFrame | null) {
  if (!frame) return null;
  const sum = (a: ArrayLike<number>, n = a.length) => {
    let s = 0;
    for (let i = 0; i < n; i++) s += a[i]!;
    return Math.round(s * 1e4) / 1e4;
  };
  return {
    fallback: frame.fallback,
    flash: frame.flash?.alpha ?? 0,
    layers: frame.layers.map((f) => ({
      id: f.layer.id,
      type: f.type,
      mode: f.mode,
      value:
        f.type === 'bars' || f.type === 'radial'
          ? sum(f.values)
          : f.type === 'waveform'
            ? sum(Array.from(f.points, Math.abs))
            : f.type === 'pulse'
              ? f.rings.length + sum(f.rings.map((r) => r.progress)) + f.core
              : f.type === 'particles'
                ? f.count + sum(f.particles, f.count * 4)
                : f.offset + f.glow,
    })),
  };
}
